//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import InfoCard from '~/components/api-docs/InfoCard.vue';
import InfoPopup from '~/components/api-docs/InfoPopup.vue';

export default BaseCmsBlock.extend({
  name: "DocV2Block",

  data: function () {
    return {
      isOpenPopUp: false
    }
  },

  computed: {
    title: function () {
      return this.$t(`documentationApi.${ this.values?.section }`)
    },
    info: function () {
      return {
        text: this.values.text,
        type: this.values.type,
        title: this.values.title,
        keySection: this.keySection
      }
    },

    section: function () {
      return this.values?.section || ""
    },
    menuTitle: function () {
      return this.values?.menu_title || ''
    },
    keySection: function () {
      return this.values?.key || [this.section, this.menuTitle].join('_')
    },

    isVisible: function () {
      return !Boolean(this.values.is_popup)
    }
  },

  components: {
    InfoCard,
    InfoPopup,
  },

  mounted: function () {
    let hash = window.location.hash;
    if (!hash) {
      return
    }

    hash = hash.replaceAll('#', '');
    if (!hash) {
      return;
    }

    hash = decodeURIComponent(String(hash));

    if (this.keySection !== hash) {
      return;
    }
    if (Number.parseFloat(this.values.is_popup || '0') === 1) {
      this.openPopUp();
      return;
    }

    const element = document.getElementById(this.keySection);
    const headerHeight = document.getElementById('siteHeader').getBoundingClientRect().height;
    const topScroll = element.getBoundingClientRect()?.top;
    document.getElementById('scroll-container').scrollTo({
      top: topScroll - headerHeight - 20 + document.getElementById('scroll-container').scrollTop
    });
  },

  methods: {
    openPopUp: function () {
      this.isOpenPopUp = true;
    },
    closePopUp: function () {
      this.isOpenPopUp = false;
    }
  }
});
